/**
 * Application routing configuration for the Symbox homepage.
 * Defines all routes, redirects, and navigation structure.
 */

import { Routes } from '@angular/router';

import { DownloadsComponent } from './pages/downloads/downloads.component';
import { ImprintComponent } from './pages/imprint/imprint.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { RedirectGuard } from './guards/redirect.guard';
import { ContactComponent } from './pages/contact/contact.component';
import { PrivateCustomersComponent } from './pages/private-customers/private-customers.component';

/**
 * Application route configuration.
 *
 * @remarks Defines the navigation structure for the Symbox homepage including:
 * - Default route (/) redirects to private customers page
 * - Main application pages (private customers, downloads, contact, imprint)
 * - External redirects for privacy policy and cancellation
 * - Wildcard route for 404 handling
 *
 */
export const routes: Routes = [
  {
    /** @remarks Default route - redirects to private customers page */
    path: '',
    component: PrivateCustomersComponent,
  },
  {
    /** @remarks Private customers landing page */
    path: 'privatkunden',
    component: PrivateCustomersComponent,
  },
  {
    /** @remarks Downloads page for user resources and files */
    path: 'downloads',
    component: DownloadsComponent,
  },
  {
    /** @remarks Contact page with contact information and forms */
    path: 'kontakt',
    component: ContactComponent,
  },
  {
    /** @remarks Legal imprint page */
    path: 'impressum',
    component: ImprintComponent,
  },
  {
    /** @remarks External redirect to privacy policy document */
    path: 'datenschutz',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://extapi.gw.inexio.net/publicDocuments.php/getDocument?id=84',
    },
  },
  {
    /** @remarks External redirect to cancellation page */
    path: 'kuendigung',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: 'https://www.inexio.net/kuendigung',
    },
  },
  {
    /** @remarks Wildcard route for 404 page not found handling */
    path: '**',
    component: PageNotFoundComponent,
  },
];
